import { formatDate } from "devextreme/localization";
import { SearchFilter, SearchReportResponseBase } from "./ISearchService";
import { Observable, of } from 'rxjs';

export interface IGetRecPlanNameSearchQuery {
  name?: string | undefined;
  type?: string | undefined;
  //roleId?: number | undefined;
  date?: string | undefined;
  endDate?: string | undefined;
  //towns?: string[] | undefined;
  towns?: string[] | undefined;
}

export class GetRecPlanNameSearchQuery implements IGetRecPlanNameSearchQuery {
  name?: string | undefined;
  type?: string | undefined;
  //roleId?: number | undefined;
  date?: string | undefined;
  endDate?: string | undefined;
  //towns?: string[] | undefined;
  towns?: string[] | undefined;

  constructor(data?: IGetRecPlanNameSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.name = data["name"];
      this.type = data["type"];
      this.date = data["date"];
      this.endDate = data["endDate"];
      //this.towns = data["town"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
    }
  }

  static fromJS(data: any): GetRecPlanNameSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecPlanNameSearchQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["type"] = this.type;
    data["date"] = this.date;
    data["endDate"] = this.endDate;
    data["towns"] = this.towns; //TODO: test this to make sure it's not a shallow copy
    //data["town"] = this.town;
    return data;
  }

}

export interface IGetRecPlanNameSearchReportQuery extends IGetRecPlanNameSearchQuery {
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterObjects?: Array<SearchFilter> | undefined;
  filterExpression?: string | undefined;

}

export class GetRecPlanNameSearchReportQuery extends GetRecPlanNameSearchQuery implements IGetRecPlanNameSearchReportQuery {
  sortBy?: string[] | undefined;
  filterExpression?: string | undefined;
  sortDirection?: string | undefined;
  filtersCollection?: string[] | undefined;
  filterObjects?: Array<SearchFilter> | undefined;

  constructor(data?: IGetRecPlanNameSearchReportQuery) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.name = data["name"];
      this.date = data["date"];
      this.endDate = data["endDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.type = data["type"];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.filterExpression = data["filterExpression"];
      this.sortDirection = data["sortDirection"];
      this.filtersCollection = [...(data["filtersCollection"] as string[])];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];
    }
  }

  static fromJS(data: any): GetRecPlanNameSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecPlanNameSearchReportQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["date"] = this.date;
    data["endDate"] = this.endDate;
    data["towns"] = this.towns;
    data["type"] = this.type;
    data["sortyBy"] = this.sortBy;
    data["filterExpression"] = this.filterExpression;
    data["sortDirection"] = this.sortDirection;
    data["filtersCollection"] = this.filtersCollection;
    data["filterObjects"] = this.filterObjects;
    return data;
  }
}

export class GetRecPlanNameSearchReportResponse extends SearchReportResponseBase { }


export interface IGetRecPlanBPSearchQuery {
  book?: string | undefined;
  page?: string | undefined;
}

export class GetRecPlanBPSearchQuery implements IGetRecPlanBPSearchQuery {
  book?: string | undefined;
  page?: string | undefined;

  constructor(data?: IGetRecPlanBPSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.book = data["book"];
      this.page = data["page"];
    }
  }

  static fromJS(data: any): GetRecPlanBPSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecPlanBPSearchQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["book"] = this.book;
    data["page"] = this.page;
    return data;
  }

}


export interface IRecPlanNameSearchListVM {
  recPlanNameSearchRows?: PlanRoomVM[] | undefined;
}

export class RecPlanNameSearchListVM implements IRecPlanNameSearchListVM {
  public recPlanNameSearchRows?: PlanRoomVM[] | undefined;
  constructor(data?: IRecPlanNameSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["planRoomRows"])) {
        this.recPlanNameSearchRows = [] as any;
        for (let item of data["planRoomRows"])
          this.recPlanNameSearchRows!.push(PlanRoomVM.fromJS(item));
      }
    }
  }
  //static fromJS(data: any): RecPlanNameSearchListVM {
  //  data = typeof data === 'object' ? data : {};
  //  let result = new RecPlanNameSearchListVM();
  //  result.init(data);
  //  return result;
  //}

  static fromJS(data: any): RecPlanNameSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RecPlanNameSearchListVM();
    result.init(data);
    // Return an Observable that emits the result
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.recPlanNameSearchRows)) {
      data["planRoomRows"] = [];
      for (let item of this.recPlanNameSearchRows)
        data["planRoomRows"].push(item.toJSON());
    }
    return data;
  }

}

export interface ISearchPlanRoom2ListVM {
  recPlanSearchRows?: PlanRoom2VM[] | undefined;
}

export class SearchPlanRoom2ListVM implements ISearchPlanRoom2ListVM {
  public recPlanSearchRows?: PlanRoom2VM[] | undefined;
  constructor(data?: ISearchPlanRoom2ListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["planRoom2Rows"])) {
        this.recPlanSearchRows = [] as any;
        for (let item of data["planRoom2Rows"])
          this.recPlanSearchRows!.push(PlanRoom2VM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): SearchPlanRoom2ListVM {
    data = typeof data === 'object' ? data : {};
    let result = new SearchPlanRoom2ListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.recPlanSearchRows)) {
      data["planRoom2Rows"] = [];
      for (let item of this.recPlanSearchRows)
        data["planRoom2Rows"].push(item.toJSON());
    }
    return data;
  }

}


export interface IPlanRoom2VM {
  planID?: number | undefined;
  year?: number | undefined;
  town?: string | undefined;
  book?: string | undefined;
  page?: string | undefined;
  owner?: string | undefined;
  surveyor?: string | undefined;
  street?: string | undefined;
  localname?: string | undefined;
  filedate?: Date | undefined;
  drawndate?: Date | undefined;
  description?: string | undefined;
  bookType?: string | undefined;

}
export class PlanRoom2VM implements IPlanRoom2VM {

  public planID?: number | undefined;
  public year?: number | undefined;
  public town?: string | undefined;
  public book?: string | undefined;
  public page?: string | undefined;
  public owner?: string | undefined;
  public surveyor?: string | undefined;
  public street?: string | undefined;
  public localname?: string | undefined;
  public fileDate?: Date | undefined;
  public drawnDate?: Date | undefined;
  public description?: string | undefined;
  public bookType?: string | undefined;

  constructor(data?: IPlanRoom2VM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.planID = data["plaN_ID"];
    this.year = data["year"];
    this.town = data["town"];
    this.book = data["book"];
    this.page = data["page"];
    this.owner = data["owner"];
    this.surveyor = data["surveyor"];
    this.street = data["street"];
    this.localname = data["localName"];
    this.fileDate = new Date();
    this.fileDate.setTime(Date.parse(data["fileDate"]));//TODO: test
    this.drawnDate = new Date();
    this.drawnDate.setTime(Date.parse(data["drawnDate"]));
    this.description = data["description"];
    this.bookType = data["bookType"];
  }

  static fromJS(data: any): PlanRoom2VM {
    data = typeof data === 'object' ? data : {};
    let result = new PlanRoom2VM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["plaN_ID"] = this.planID;
    data["fileDate"] = formatDate(this.fileDate, "shortDate");
    data["drawnDate"] = formatDate(this.drawnDate, "shortDate");
    data["year"] = this.year;
    data["town"] = this.town;
    data["book"] = this.book;
    data["page"] = this.page;
    data["owner"] = this.owner;
    data["surveyor"] = this.surveyor;
    data["street"] = this.street;
    data["localName"] = this.localname;
    data["fileDate"] = formatDate(this.fileDate, "shortDate");
    data["drawnDate"] = formatDate(this.drawnDate, "shortDate");
    data["description"] = this.description;
    data["bookType"] = this.bookType;

  }

}

export interface IPlanRoomVM {
  planID?: number | undefined;
  year?: number | undefined;
  town?: string | undefined;
  book?: string | undefined;
  page?: string | undefined;
  owner?: string | undefined;
  surveyor?: string | undefined;
  street?: string | undefined;
  localname?: string | undefined;
  fileDate?: Date | undefined;
  drawnDate?: Date | undefined;
  description?: string | undefined;
  bookType?: string | undefined;

}
export class PlanRoomVM implements IPlanRoomVM {

  public planID?: number | undefined;
  public year?: number | undefined;
  public town?: string | undefined;
  public book?: string | undefined;
  public page?: string | undefined;
  public owner?: string | undefined;
  public surveyor?: string | undefined;
  public street?: string | undefined;
  public localname?: string | undefined;
  public fileDate?: Date | undefined;
  public drawnDate?: Date | undefined;
  public description?: string | undefined;
  public bookType?: string | undefined;

  constructor(data?: IPlanRoomVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.planID = data["plaN_ID"];
    this.year = data["year"];
    this.town = data["town"];
    this.book = data["book"];
    this.page = data["page"];
    this.owner = data["owner"];
    this.surveyor = data["surveyor"];
    this.street = data["street"];
    this.localname = data["localName"];
    this.fileDate = new Date();
    this.fileDate.setTime(Date.parse(data["fileDate"]));//TODO: test
    this.drawnDate = new Date();
    this.drawnDate.setTime(Date.parse(data["drawnDate"]));
    this.description = data["description"];
    this.bookType = data["bookType"];
  }

  static fromJS(data: any): PlanRoomVM {
    data = typeof data === 'object' ? data : {};
    let result = new PlanRoomVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["plaN_ID"] = this.planID;
    data["fileDate"] = formatDate(this.fileDate, "shortDate");
    data["drawnDate"] = formatDate(this.drawnDate, "shortDate");
    data["year"] = this.year;
    data["town"] = this.town;
    data["book"] = this.book;
    data["page"] = this.page;
    data["owner"] = this.owner;
    data["surveyor"] = this.surveyor;
    data["street"] = this.street;
    data["localName"] = this.localname;
    data["fileDate"] = formatDate(this.fileDate, "shortDate");
    data["drawnDate"] = formatDate(this.drawnDate, "shortDate");
    data["description"] = this.description;
    data["bookType"] = this.bookType;

  }

}

export class PlanImgPage {
  // $LoudName
  public imgLabel: string;
  // $LoudName
  public imgPath: string;
  // $LoudName
  public imgPage: number;
}

export class PlanImgObject {
  // $LoudName
  public imgType: string;
  // $LoudName
  public pageList: PlanImgPage[];
}



export interface IGetRegPlanOwnerSearchQuery {
  ownerName?: string | undefined;
  towns?: string[] | undefined;
}

export class GetRegPlanOwnerSearchQuery implements IGetRegPlanOwnerSearchQuery {
  ownerName?: string | undefined;
  towns?: string[] | undefined;

  constructor(data?: IGetRegPlanOwnerSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.ownerName = data["ownerName"];
      this.towns = [...(data["towns"] as string[])];
    }
  }

  static fromJS(data: any): GetRegPlanOwnerSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegPlanOwnerSearchQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ownerName"] = this.ownerName;
    data["towns"] = this.towns;
    return data;
  }

}

export interface IGetRegPlanStreetSearchQuery {
  street?: string | undefined;
  towns?: string[] | undefined;
}

export class GetRegPlanStreetSearchQuery implements IGetRegPlanStreetSearchQuery {
  street?: string | undefined;
  towns?: string[] | undefined;

  constructor(data?: IGetRegPlanStreetSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.street = data["street"];
      this.towns = [...(data["towns"] as string[])];
    }
  }

  static fromJS(data: any): GetRegPlanStreetSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegPlanStreetSearchQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["street"] = this.street;
    data["towns"] = this.towns;
    return data;
  }

}

export interface IGetRegGetPlanPagesQuery {
  planName?: string | undefined;
  imageType?: string | undefined;
  imageExtension?: string | undefined;
  pathType?: number | undefined;

}

export class GetRegGetPlanPagesQuery implements IGetRegGetPlanPagesQuery {
  planName?: string | undefined;
  imageType?: string | undefined;
  imageExtension?: string | undefined;
  pathType?: number | undefined;

  constructor(data?: IGetRegGetPlanPagesQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.planName = data["planName"];
      this.imageType = data["imageType"];
      this.imageExtension = data["imageExtension"];
      this.pathType = data["pathType"];

    }
  }

  static fromJS(data: any): GetRegGetPlanPagesQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegGetPlanPagesQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["planName"] = this.planName;
    data["imageType"] = this.imageType;
    data["imageExtension"] = this.imageExtension;
    data["pathType"] = this.pathType;
    return data;
  }

}


export interface ILCPlansVM {
  planCaseNum?: string | undefined;
  certID?: number | undefined;
  certNum?: string | undefined;
  planID?: number | undefined;
  townAbbrName?: string | undefined;
  strtName?: string | undefined;
  strtNum?: string | undefined;
  ownerName?: string | undefined;
}
export class LCPlansVM implements ILCPlansVM {

  public planCaseNum?: string | undefined;
  public certID?: number | undefined;
  public certNum?: string | undefined;
  public planID?: number | undefined;
  public townAbbrName?: string | undefined;
  public strtName?: string | undefined;
  public strtNum?: string | undefined;
  public ownerName?: string | undefined;

  constructor(data?: ILCPlansVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.planCaseNum = data["planCaseNum"];
    this.certID = data["certID"];
    this.certNum = data["certNum"];
    this.planID = data["planID"];
    this.townAbbrName = data["townAbbrName"];
    this.strtName = data["strtName"];
    this.strtNum = data["strtNum"];
    this.ownerName = data["ownerName"];
  }

  static fromJS(data: any): LCPlansVM {
    data = typeof data === 'object' ? data : {};
    let result = new LCPlansVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["planCaseNum"] = this.planCaseNum;
    data["certID"] = this.certID;
    data["certNum"] = this.certNum;
    data["planID"] = this.planID;
    data["townAbbrName"] = this.townAbbrName;
    data["strtName"] = this.strtName;
    data["strtNum"] = this.strtNum;
    data["ownerName"] = this.ownerName;
  }

}

export interface ILCPlansListVM {
  regPlanSearchRows?: LCPlansVM[] | undefined;
}


export class LCPlansListVM implements ILCPlansListVM {
  public regPlanSearchRows?: LCPlansVM[] | undefined;
  constructor(data?: ILCPlansListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["lcPlanRows"])) {
        this.regPlanSearchRows = [] as any;
        for (let item of data["lcPlanRows"])
          this.regPlanSearchRows!.push(LCPlansVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): LCPlansListVM {
    data = typeof data === 'object' ? data : {};
    let result = new LCPlansListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.regPlanSearchRows)) {
      data["lcPlanRows"] = [];
      for (let item of this.regPlanSearchRows)
        data["lcPlanRows"].push(item.toJSON());
    }
    return data;
  }

}

export interface IGetSBImagesQuery {
  emailList?: boolean | undefined;
  emailAddress?: string | undefined;
  zipList?: boolean | undefined;
  sBList?: Array<SBListDTO>;
  sBCred?: string | undefined;
  subType?: number | undefined;
  intID?: string | undefined;
  intDesc?: string | undefined;
  optPhone?: string | undefined;
  optZCode?: string | undefined;
}
export class GetSBImagesQuery implements IGetSBImagesQuery {
  public emailList?: boolean | undefined;
  public emailAddress?: string | undefined;
  public zipList?: boolean | undefined;
  public sBList?: SBListDTO[] | undefined;
  sBCred?: string | undefined;
  subType?: number | undefined;
  intID?: string | undefined;
  intDesc?: string | undefined;
  optPhone?: string | undefined;
  optZCode?: string | undefined;

  constructor(data?: IGetSBImagesQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    this.emailList = data["emailList"];
    this.emailAddress = data["emailAddress"];
    this.zipList = data["zipList"];
    if (Array.isArray(data["sBList"])) {
      this.sBList = [] as any;
      for (let item of data["sBList"])
        this.sBList!.push(SBListDTO.fromJS(item));
    }
    this.sBCred = data["sBCred"];
    this.subType = data["subType"];
    this.intID = data["intID"];
    this.intDesc = data["intDesc"];
    this.optPhone = data["optPhone"];
    this.optZCode = data["optZCode"];
  }
  static fromJS(data: any): GetSBImagesQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetSBImagesQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailList"] = this.emailList;
    data["emailAddress"] = this.emailAddress;
    data["zipList"] = this.zipList;
    if (Array.isArray(this.sBList)) {
      data["sBList"] = [];
      for (let item of this.sBList)
        data["sBList"].push(item.toJSON());
    }
    data["sBCred"] = this.sBCred;
    data["subType"] = this.subType;
    data["intID"] = this.intID;
    data["intDesc"] = this.intDesc;
    data["optPhone"] = this.optPhone;
    data["optZCode"] = this.optZCode;
    return data;

  }
}

export interface ISBListDTO {
  imageType?: string | undefined; //pdf = PDF, tif = TIFF
  department?: string | undefined; //R = recorded land, L = registered land
  bookDoc?: string | undefined;
  bookPage?: string | undefined;
  pages?: string[] | undefined;
  wholeDoc?: boolean | undefined;
  docType?: string | undefined;
  docPageCount?: number | undefined;
}

export class SBListDTO implements ISBListDTO {
  public imageType?: string | undefined; //pdf = PDF, tif = TIFF
  public department?: string | undefined; //R = recorded land, L = registered land
  public bookDoc?: string | undefined;
  public bookPage?: string | undefined;
  public pages?: Array<string> | undefined;
  public wholeDoc?: boolean | undefined;
  public docType?: string | undefined;
  public docPageCount?: number | undefined;

  constructor(data?: ISBListDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.imageType = data["imageType"];
    this.department = data["department"];
    this.bookDoc = data["bookDoc"];
    this.bookPage = data["bookPage"];
    if (Array.isArray(data["pages"])) {
      this.pages = [];
      for (let item of data["pages"])
        this.pages!.push(item);
    }

    this.wholeDoc = data["wholeDoc"];
    this.docType = data["docType"];
    this.docPageCount = data["docPageCount"]
  }
  static fromJS(data: any): SBListDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SBListDTO();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["imageType"] = this.imageType;
    data["department"] = this.department;
    data["bookDoc"] = this.bookDoc;
    data["bookPage"] = this.bookPage;
    if (Array.isArray(this.pages)) {
      data["pages"] = [];
      for (let item of this.pages)
        data["pages"].push(item);
    }

    data["wholeDoc"] = this.wholeDoc;
    data["docType"] = this.docType;
    data["docPageCount"] = this.docPageCount;
    return data;

  }


}

export class basketVM {
  pageCount: number;
  isEmail: boolean;
  emailAs: string;
  isDownload: boolean;
  downloadAs: string;
  isPDF: boolean;
  isTIF: boolean;
  wholeDoc: boolean;
  pages: Array<string>;
  imagepaths: Array<string>;
  planname: string | undefined;
  book: string | undefined;
  page: string | undefined;
  dept: string;
  document: string | undefined;
  docType: string | undefined;
}

export class IndexGroupsVM {
  dateRange: string;

  dateGroup: number;

  torTee: number;

  active: string;

  majorGrouop: number;
}

export class IndexVM {
  indexName: string;
  indexImagePath: string;
  indexBook: string;
  indexPage: string;
  indexGroup: string;
  dateGroup: number;
}



